module.exports = __webpack_public_path__ + "static/media/astronauts.71addf45.svg";